$(() => {
  const assumed_impact_of_reputational_dmg = () => {
    const net_patient_revenue = parseInt($('#net-patient-revenue').val().replaceAll(',', ''), 10);

    if (net_patient_revenue < 5000000001) {
      return 0.5;
    }

    return 0.25;
  };

  const run = () => {
    if ($('#assumed-impact-of-reputational-dmg-overridden').val() === '0') {
      $('#assumed-impact-of-reputational-dmg').val(assumed_impact_of_reputational_dmg());
    }
  };

  run();

  $('#net-patient-revenue').blur(() => {
    run();
  });

  $('#assumed-impact-of-reputational-dmg').blur(() => {
    $('#assumed-impact-of-reputational-dmg-overridden').val('1');
  });
});
